import { AxiosError } from 'axios'
import { apiUrls, settings } from 'consts'
import { axiosPut } from 'shared/api/axios'
import { setSettingsValue } from 'shared/components/App/Auth'
import displayError from 'shared/utils/displayError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const data: {} = {
    [settings.pageSize]: props.data.pageSize.id,
  }

  props.setShowOverlay(true)

  const catchFunc = (err: AxiosError) => {
    displayError({
      errorMessage: err?.response?.data?.message ?? 'An error has occurred.',
      setShowOverlay: props.setShowOverlay,
    })
  }

  //update settings on the server and update Store
  response = await axiosPut(apiUrls.settings + '/' + apiUrls.actionBulkUpdate, data, catchFunc)

  if (response) {
    setSettingsValue(settings.pageSize, props.data.pageSize.id)
  }

  return true
}

export default submitForm
